import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { AlertService, HString } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-route-part-cmr-page',
    templateUrl: './shared.external.route.part.cmr.digitaldocument.page.html',
    styleUrls: ['./shared.external.route.part.cmr.digitaldocument.page.scss']
})
export class SharedExternalRoutePartCMRDigitalDocumentPage implements OnInit {


    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
        this.getDades();
    }

    public uuid: string = "";
    public getDades() {
        this.activatedRoute.params.subscribe(a => {
            this.uuid = a.uuidQR;
            this.getRoutePartCMRIdByQR();
        });
    }

    public __showSignature: boolean = true;
    @Input()
    public set showSignature(value: boolean) {
        if (this.__showSignature === value)
            return;
        this.__showSignature = value;
    }
    public get showSignature(): boolean {
        return this.__showSignature;
    }


    public routePartCMRId: number;
    getRoutePartCMRIdByQR() {

        if (HString.isNullOrNullString(this.uuid)) {
            this.routePartCMRId = 0;
        } else {
            this.openRouteCMRController.getRoutePartCMRByUUID(this.uuid).subscribe(d => {
                if(d)
                    this.routePartCMRId = d.routePartCMRId;
                else
                    this.routePartCMRId = 0;
            });
        }
    }


    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
